import { Node, mergeAttributes } from "@tiptap/core";

/**
 * Bloc encadré coloré : englobe un ou plusieurs paragraphes dans un
 * conteneur avec fond et texte colorés — contrairement à une marque inline
 * (type Highlight), qui ne teinte que le texte sélectionné ligne par ligne
 * sans jamais former un rectangle continu sur plusieurs lignes/paragraphes.
 */
export const ColorBlock = Node.create({
  name: "colorBlock",
  group: "block",
  content: "block+",
  defining: true,

  addAttributes() {
    return {
      backgroundColor: { default: "#fef3c7" },
      color: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: "div[data-color-block]" }];
  },

  renderHTML({ HTMLAttributes, node }) {
    const styles = [
      `background-color:${node.attrs.backgroundColor}`,
      "padding:12px 16px",
      "border-radius:8px",
      "margin:8px 0",
    ];
    if (node.attrs.color) styles.push(`color:${node.attrs.color}`);
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-color-block": "true",
        style: styles.join(";"),
      }),
      0,
    ];
  },
});
